/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsLabel: {
  name: 'label';
  data: string;
} = {
  name: 'label',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.11 3.006A1 1 0 0 0 3.006 4.11l1 9.001a1 1 0 0 0 .287.597l7 7a1 1 0 0 0 1.414 0l8-8a1 1 0 0 0 0-1.415l-7-7a1 1 0 0 0-.597-.286l-9-1Zm1.845 9.535-.823-7.409 7.409.824L18.586 12 12 18.586l-6.045-6.044ZM8.5 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" fill="currentColor"/></svg>`,
};
